import { useQuery } from '@tanstack/react-query';
import { PAYMENT_DATA_QUERY_KEY } from './payment.constants';
import { getPaymentData } from './payment.requests';

export const usePaymentData = (
  id: string,
  { enabled = true, retry = 1 }: { enabled?: boolean; retry?: number } = {},
) =>
  useQuery({
    queryKey: [PAYMENT_DATA_QUERY_KEY, id],
    queryFn: () => getPaymentData(id),
    retry,
    retryDelay: () => 3000,
    enabled,
  });
